import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDay2026PrimaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

LaborDay2026PrimaryOne.palette['--sui-palette-background-primary'] = '185 67 14';

export { LaborDay2026PrimaryOne };